<template>
<div id="page-carga_adjuntos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Ordenes Abiertas" class="elevation-1 px-5 py-3" >
                <v-card-actions>
                                      <v-spacer></v-spacer>
                                     <v-btn fab dark x-small color="green" @click.native="downloadURL();" title="Descargar en Excel" v-tippy>
                                        <v-icon dark>mdi-table</v-icon>
                                    </v-btn>

                                    </v-card-actions> 
                                    
                    <v-card-text>
                
              <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >


                            <v-client-table ref="vuetable" id="lista_clientes"  :data="data.items"
                             :columns="columns" 
                             :options="options" 
                             class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                               
                              <template slot="afterTable" >
                                <div v-if="pwPagination.total > 0" >
                                    <div class="mt-3" >
                                        <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="data" :options="pwPagination.options" ></PaginacionComponent>
                                    </div>
                                </div>
                            </template>
                            </v-client-table>
                           
                        </div>

                    </v-card-text>
                </base-material-card>

             
      <!--     <v-card-actions>
            <v-btn
              color="success"
              min-width="100"
              class="pl-0"
            >
              Sign In
            </v-btn>
          </v-card-actions> -->
            </v-flex>
        </v-layout>

    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
    created: function () {
        this.URL = this.$hostname;
        this.cliente = this.$local_storage.get("id_cliente");
         this.cargar();
    },
     mounted: function() {
       
        this.model_filters = this.$refs.vuetable.query;
        
    },
     watch: {
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    id_orden_abierta: parseInt(this.cliente),
                    filtros: {
                        reg_control__icontains: this.model_filters.reg_control,
                        planta__icontains: this.model_filters.planta,
                        destination_ingreso__icontains: this.model_filters.destination,
                        pu_num__icontains: this.model_filters.pu_num,
                        po_line_num__icontains: this.model_filters.po_line_num,
                        vendor__icontains: this.model_filters.vendor,
                        no_parte__icontains: this.model_filters.no_parte,
                        item_desc__icontains: this.model_filters.item_desc,
                        qty__icontains: this.model_filters.qty,
                        uom__icontains: this.model_filters.uom,
                        unit_price__icontains: this.model_filters.unit_price,
                        currency__icontains: this.model_filters.currency,
                        ext_cur__icontains: this.model_filters.ext_cur,
                        ext_dol__icontains: this.model_filters.ext_dol,


                    }
                }
            },
            deep: true
        }
    },
     components: {
        "PaginacionComponent": PaginacionComponent
    },
    data() {
        return {
            fab: false,
            URL: "",
            key_descarga: "",
            model_filters: '',
            pwPagination: {
                total: 0,
                links: {
                    url: this.$hostname + "reportes/ordenes_abiertas_detalle/",
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 20,
                    loading: this.showLoading,
                    filters: {}
                }
            },
            data: {
                selected: [],
                headers: [{
                        text: "",
                        value: "icon"
                    },
                    {
                        text: "RFC ",
                        value: "rfc"
                    },
                    {
                        text: "RAZÓN SOCIAL ",
                        value: "razon"
                    }
                ],
                items: [0]
            },
            name: "datagrid",
            columns: [
                "reg_control",
                    "planta",
                    "destination",
                    "pu_num",
                    "po_line_num",
                    "vendor",
                    "no_parte",
                    "item_desc",
                    "qty",
                    "uom",
                    "unit_price",
                    "currency",
                    "ext_cur",
                    "ext_dol",
            ],
            
            options: {
                texts:{
                    count:"",
                },
                perPage: 20,
                filterable: ["reg_control",
                    "planta",
                    "destination",
                    "pu_num",
                    "po_line_num",
                    "vendor",
                    "no_parte",
                    "item_desc",
                    "qty",
                    "uom",
                    "unit_price",
                    "currency",
                    "ext_cur",
                    "ext_dol",],
                sortable: ["reg_control",
                    "planta",
                    "destination",
                    "pu_num",
                    "po_line_num",
                    "vendor",
                    "no_parte",
                    "item_desc",
                    "qty",
                    "uom",
                    "unit_price",
                    "currency",
                    "ext_cur",
                    "ext_dol",],
                headings: {
                    "reg_control": "reg_control", 
                    "planta": "planta", 
                    "destination": "destination", 
                    "pu_num": "pu_num",
                    "po_line_num": "po_line_num", 
                    "vendor": "vendor",
                    "no_parte": "no_parte",
                    "item_desc": "item_desc",
                    "qty": "qty", 
                    "uom": "uom", 
                    "unit_price":  "unit_price", 
                    "currency": "currency", 
                    "ext_cur": "ext_cur", 
                    "ext_dol": "ext_dol"
                },
                filterAlgorithm: {
                    no_parte: function() {return true;},
                    reg_control: function() {return true;},
                    planta: function() {return true;},
                    pu_num: function() {return true;},
                    
                },
            },
            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Ordenes Abiertas",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {
        getCamposLayout: function () {
            axios
                .get(this.$hostname + "catalogos/templates/campos_doc/ ")
                .then(response => {
                    this.camposLayout = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                });
        },
        pickFile() {
            this.$refs.file_input.click()
        },
         downloadURL: function () {
           
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: this.key_descarga,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargar: function () {
            let self = this;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let data = {
                "id_orden_abierta": parseInt(self.cliente),
            };
            axios
                .post(this.URL + "reportes/ordenes_abiertas_detalle/?limit=20", data)
                .then((res) => {
                    self.key_descarga =   res.data.key;  
                    self.data.items= res.data.results;
                    self.pwPagination.total = res.data.count;
                    self.pwPagination.links.next = res.data.next;
                    self.pwPagination.links.prev = res.data.previous;
                    self.key_descarga = res.data.key;  
                })
                .catch((err) => {
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        
        
    }
};
</script>
